import { useState } from "react";
import TitleBar from "../../layout/TitleBar";
import Layout from "../../layout/Layout";
import { addReferral } from "../../../actions/admin/referral";
import Alert from "../../layout/Alert";
import { useDispatch } from "react-redux";

const AddReferral = () => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        name: "",
        website: "",
        code: "",
        isActive: true,
    });

    const {
        name,
        website,
        code,
        isActive,
    } = formData;

    const [isActiveState, setIsActiveState] = useState(true);

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (e.target.name === 'isActive') setIsActiveState(!isActiveState);
    }

    const onFormSubmit = (e) => {
        console.log(formData)
        e.preventDefault();

        dispatch(addReferral(formData));
        setFormData({
            name: "",
            website: "",
            code: "",
            isActive: true,
        });

    };

    return (
        <Layout>
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4 w-100">
                <TitleBar title="Add Referral" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="card mb-3">
                                <div className="card-header">Copmany Details</div>
                                <div className="card-body">

                                    <div className="mb-3">
                                        <label className="label mb-2">Name:</label>
                                        <div className="col-sm-12">
                                            <input
                                                type="text"
                                                className="form-control form-control-admin"
                                                id="name"
                                                placeholder="Enter Company Name"
                                                name="name"
                                                value={name}
                                                onChange={(e) => onChange(e)}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="label mb-2">Website:</label>
                                        <div className="col">
                                            <input
                                                type="text"
                                                className="form-control form-control-admin"
                                                id="website"
                                                placeholder="Enter Website"
                                                name="website"
                                                value={website}
                                                onChange={(e) => onChange(e)}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="label mb-2">Code:</label>
                                        <div className="col">
                                            <input
                                                type="text"
                                                className="form-control form-control-admin"
                                                id="code"
                                                placeholder="Enter Referral Code"
                                                name="code"
                                                value={code}
                                                onChange={(e) => onChange(e)}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <div className="col-sm-12">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="isActive"
                                                checked={isActiveState}
                                                name="isActive"
                                                onChange={(e) => {
                                                    setIsActiveState(!isActiveState);
                                                    setFormData({ ...formData, isActive: !isActiveState });
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="isActive"> &nbsp; Active</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-3">
                                <div className="col-sm-offset-2 col-sm-10">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        onClick={(e) => onFormSubmit(e)}
                                    >
                                        <i
                                            className="fa fa-plus-circle fa-fw"
                                            aria-hidden="true"
                                        ></i>{" "}
                                        Add Referral
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Alert />
            </main>
        </Layout>
    );
};

export default AddReferral;
